module.exports = __webpack_public_path__ + "img/hiw.ff59e6b9.png";